export const SITE_URL = 'https://www.movimentorivoluzionefiscale.it'
export const SITE_NAME = 'Movimento Rivoluzione Fiscale'
export const SITE_DESCRIPTION = 'Sito ufficiale del Movimento Rivoluzione Fiscale (MRF): progetto politico, proposte, comunicati, notizie e documenti dell’associazione.'
